import { render, staticRenderFns } from "./betHistory.vue?vue&type=template&id=fc75b0f6&scoped=true"
import script from "./betHistory.vue?vue&type=script&lang=js"
export * from "./betHistory.vue?vue&type=script&lang=js"
import style0 from "./betHistory.vue?vue&type=style&index=0&id=fc75b0f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc75b0f6",
  null
  
)

export default component.exports